// extracted by mini-css-extract-plugin
module.exports = {"button":"DeleteButton_button__1XqAA","icon":"DeleteButton_icon__3fxM0 close_close__167jw close_close_white__ShuA2"};